import React, { useEffect } from 'react';
import { Content, Header, List, Title, Wrapper } from './side-list-organizations.styles';
import { Typography } from '../../../shared/ui/typography/typography';
import { Tag } from '@vtbhome/juicyfront';
import { ArrowsChevronRight } from '@vtbhome/juicyfront/indexIcon';
import { CardSide } from '../../../shared/ui/card-side/card-side';
import { COLORS } from '../../../shared/config/colors/colors';
import { useOrganizationsListSharedQuery } from '@entities/organization/libs/hooks/use-organizations-list-shared-query/use-organizations-list-shared-query';
import { DEFAULT_ORGANIZATIONS_LIST_PARAMETERS } from '@entities/organization/config/store-constants';
import { ROUTE_ADMIN_ORGANIZATIONS } from '@shared/config/routes/routes';
import { OrganizationsListDataRequest } from '@entities/organization/api/organization-types';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { NetworkStateNew } from '@shared/ui/network-state-new/network-state-new';
import { Search } from '@shared/ui/search/search';
import { getOrganizationDescription } from './../libs/get-organization-description';
import { useSearchParams } from '@shared/lib/hooks/use-search-params/use-search-params';
import { LinkScroll } from '@shared/ui/link-scroll/link-scroll';

export const SideListOrganizations: React.FC = () => {
    const [organizationsListParameters, setorganizationsListParameters] = useSearchParams<OrganizationsListDataRequest>(
        DEFAULT_ORGANIZATIONS_LIST_PARAMETERS
    );
    const [getOrganizationsList, getOrganizationsListResult] =
        useOrganizationsListSharedQuery(organizationsListParameters);

    const organizationsListLength = getOrganizationsListResult.data?.items.length || 0;
    const isLoading =
        getOrganizationsListResult.isFetching ||
        getOrganizationsListResult.isLoading ||
        getOrganizationsListResult.isUninitialized;
    const organizationsError = getQueryError(getOrganizationsListResult);

    useEffect(() => {
        getOrganizationsList(organizationsListParameters);
    }, [organizationsListParameters]);

    return (
        <Wrapper>
            <Header>
                <Title>
                    <Typography size='h6'>Организации</Typography>
                    {!isLoading && <Tag variant='lightBlue'>{organizationsListLength}</Tag>}
                </Title>
                <LinkScroll to={ROUTE_ADMIN_ORGANIZATIONS}>
                    <ArrowsChevronRight color={COLORS.neutral_50} />
                </LinkScroll>
            </Header>
            <Content>
                <Search
                    parameters={organizationsListParameters}
                    setParameters={setorganizationsListParameters}
                    placeholder='Поиск по названию или ИНН'
                />
                <List>
                    <NetworkStateNew
                        isLoading={isLoading}
                        isInitialized={Boolean(getOrganizationsListResult.data)}
                        isError={Boolean(organizationsError)}
                        isFiltered={Boolean(getOrganizationsListResult.data?.search)}
                        hasData={Boolean(organizationsListLength)}
                        errorProps={{
                            title: 'Ошибка загрузки организаций',
                            description: organizationsError?.message,
                        }}
                        emptyProps={{
                            title: 'Организации отсутствуют',
                        }}
                        emptyFilteredProps={{
                            title: 'Организации не найдены',
                        }}>
                        {getOrganizationsListResult.data?.items.map((organization) => (
                            <CardSide
                                key={organization.id}
                                title={`${organization.shortName} (${organization.inn})`}
                                description={getOrganizationDescription(
                                    organization.countUsers,
                                    organization.countProducts
                                )}
                                tagChildren={organization.active ? 'Активна' : 'Заблокирована'}
                                tagVariant={organization.active ? 'green' : 'grey'}
                            />
                        ))}
                    </NetworkStateNew>
                </List>
            </Content>
        </Wrapper>
    );
};
